export const IconTags = {
  METHOD_LOGO_TAG: 'logo_large_rectangle_light',
  BRAND_LOGO_TAG: 'logo_small_square_light'
};
//# sourceMappingURL=constants.js.map